import classNames from "classnames"

type LoaderProps =
  | {
      size?: "small" | "small-1" | "medium" | "large"
      style?: "ghost" | "spinner"
      inline?: false
    }
  | {
      size?: undefined
      style?: undefined
      inline: true
    }

function Loader({
  size = "medium",
  style = "ghost",
  inline = false,
}: LoaderProps) {
  if (inline) {
    return (
      <span className="spin-loader spin-loader--inline">
        <span className="sr-only">Loading</span>
      </span>
    )
  }

  const classList = classNames({
    loader: style === "ghost",
    "spin-loader": style === "spinner",
    [`loader--${size}`]: size,
  })

  return (
    <div className={classList}>
      <span className="sr-only">Loading</span>
    </div>
  )
}

export default Loader
